$(document).ready(function(){

    var form = $("#resetMdpForm");

    initResetMdpFormValidate(form, rootUrl);
});

function initResetMdpFormValidate(form, rootUrl){

    $.extend($.validator.messages, {
        required: "Veuillez renseigner ce champ",
        equalTo: "La confirmation est différente du nouveau mot de passe, veuillez la saisir à nouveau"
    });

    form.validate({
        onkeyup: false,
        onfocusout: false,
        errorElement: "div",
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        rules: {
            "newPwd":{
                required: true
            },
            "newPwdConfirm": {
                equalTo: "#newPwd"
            }
        }
    });
}
